import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const workshopsApi = createApi({
  reducerPath: 'workshopsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getWorkshops: builder.query({
      query: (id) => ({
        url: urls.foWorkshops(id),
      }),
    }),
    getWorkshop: builder.query({
      query: (id) => ({
        url: urls.foWorkshopDetail(id),
        method: 'GET',
      }),
    }),
    // getAllWorkshops: builder.query({
    //   query: () => {
    //     return {
    //       url: urls.foAllWorkshops,
    //     }
    //   },
    // }),
    saveWorkshop: builder.mutation({
      query({ workshopId, eventId, data }) {
        const formData = {
          fo_event_id: Number(eventId),
          description: data.description,
          name: data.name,
          lecturer_id: data.lecturer_id,
          creator_id: data.creator_id,
        };
        if (workshopId) {
          return {
            url: urls.foWorkshopDetail(workshopId),
            method: 'PATCH',
            data: formData,
          };
        } else {
          return {
            url: urls.foWorkshopsStore,
            method: 'POST',
            data: formData,
          };
        }
      },
    }),
    deleteWorkshop: builder.mutation({
      query(id) {
        return {
          url: urls.foWorkshopDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetWorkshopsQuery,
  useGetWorkshopQuery,
  useSaveWorkshopMutation,
  useDeleteWorkshopMutation,
} = workshopsApi;
